/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/factory_orbital': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10 15h3v13h-3zM11.5 13s1.5 0 1.5 1h-3c0-1 1.5-1 1.5-1zM12 12h-1v-2c.01-.124.091-.798.646-1.354s1.229-.637 1.305-.644L15 8c.293 0 .766-.473 1.146-.854l.08-.08C16.606 6.688 17 6.295 17 6V4h1v2c0 .711-.543 1.252-1.068 1.775l-.079.078C16.29 8.417 15.707 9 15 9h-1.996c.012.002-.358.062-.65.354a1.32 1.32 0 00-.356.701L12 12zM18 20v4l-4-4v6h8v-2zM14 27h8v1h-8z"/><path pid="1" d="M15 32H0V17h1v14h14zM32 32H17v-1h14V17h1zM32 15h-1V1H17V0h15zM1 15H0V0h15v1H1z"/>'
  }
})
